import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import * as XLSX from 'xlsx';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "jspdf-autotable";

import Header from "../../components/header";
import Sidebar from "../../components/sidebar";
import Footer from "../../components/footer";
import Loader from '../../components/loader';

function LedgerReport() {

    const [orderData, setData] = useState([]);
    const today = new Date().toISOString().split('T')[0];
    const [eDate, setEDate] = useState(today);
    const [sDate, setSDate] = useState(today);
    const [loader, setLoader] = useState(false);


    const formatDate = (date) => {     
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${String(newDate.getDate()).padStart(2, '0')}`;
        return formattedDate;
    };

    const formatViewDate = (date) => {
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }

        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", 
                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        const formattedDate = `${String(newDate.getDate()).padStart(2, '0')}-${months[newDate.getMonth()]}-${newDate.getFullYear()}`;

    
        // const formattedDate = `${String(newDate.getDate()).padStart(2, '0')}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${newDate.getFullYear()}`;
        return formattedDate;
    };

    const formatSendDate = (dateStr) => {
        const date = new Date(dateStr);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-based
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}/${month}/${day}`;
    };

    const formatReturnDate = (dateString) => {
        const date = new Date(dateString); // Create a Date object from input string
        const month = date.toLocaleString('default', { month: 'long' }); // Full month name
        const year = date.getFullYear().toString().slice(-2); // Last two digits of the year
        return `${month} - ${year}`; // Format: "September - 25"
    };

    const getData = async () => {
        setLoader(true);
        const sendData = {
            sDate: formatSendDate(sDate),
            eDate: formatSendDate(eDate)
        };

        try {
            const response = await axios.post('https://api.trucoo.in/invoice/monthly-report/', sendData, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });

            if (response.data.status === "success") {
                setData(response.data.data);
            } else {
                console.error("Error fetching data");
                setData([]); 
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
            setData([]); 
        }
        setLoader(false);
    };


    const getFiscalYearLabel = (date = new Date()) => {
        const year = date.getFullYear();
        const month = date.getMonth(); 
        if (month < 3) {
          return `${(year-1).toString().slice(-2)}-${year.toString().slice(-2)}`;
        } else {
          return `${year.toString().slice(-2)}-${(year + 1).toString().slice(-2)}`;
        }
    };

    const exportToExcel = () => {
        const ws = XLSX.utils.table_to_sheet(document.getElementById('printableArea'));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Daily Sales Report');
        XLSX.writeFile(wb, `Daily_Sales_Report_${formatDate(sDate)}_${formatDate(eDate)}.xlsx`);
    };

    const getDiscount = (discountData, itemId) => {
        const discountItem = discountData?.length > 0 ? discountData.filter(discount => discount.item === itemId) : null;
        // console.log(discountData);
        // console.log(discountItem);
        if(discountItem?.length > 0){
            return discountItem[0];
        }else{
            return null;
        }
    };

    const flattened = orderData.flatMap(entry =>
        entry.orderData.map(item => ({
            id: entry.id,
            invoiceId: entry.invoiceId,
            dealerId: entry.dealerId,
            date: entry.date,
            gstType: entry.gstType,
            vNum: entry.vNum,
            eWayNum: entry.eWayNum,

            party: entry.dealerData.dealer,
            gstin: entry.dealerData.gst,
            state: entry.dealerData.state,
            location: entry.dealerData.location,
            stateCode: entry.dealerData.stateCode,

            item: item.itemName,
            itemCode: item.itemCode,
            qty: item.qty,
            price: item.itemPrice,
            hsn: item.itemHsn,
            crates: item.itemGrade,
            gst: item.itemGst,
            weight: item.itemWeight,
            discount: getDiscount(JSON.parse(entry.discountData), item.itemId)
        }))
    );

    // console.log(flattened);

    return (
        <>
            {loader && <Loader /> }
            <Header />
            <Sidebar />

            <div className="content-wrapper">
                <div className="container-full">
                    <section className="content">
                        <div className="box">
                            <div className="box-header with-border">
                                    
                                <div className="row" >
                                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12" >
                                        <h4 className="box-title">Tally Export</h4>
                                        <p className="mb-0 box-subtitle">Invoices1</p>
                                    </div>
                                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12" >
                                        <div className="input-group">
                                            <input
                                                type="date"
                                                value={formatDate(sDate)}
                                                onChange={(e) => setSDate(e.target.value)}
                                                className="form-control"
                                            />
                                    
                                            <input
                                                type="date"
                                                value={formatDate(eDate)}
                                                onChange={(e) => setEDate(e.target.value)}
                                                className="form-control"
                                            />
                                    
                                            <button class="btn btn-sm btn-success" onClick={getData} >Get Report</button>
                                        </div>
                                    </div>
                                   
                                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-12" align="right">
                                        <button className="btn btn-sm btn-warning" onClick={exportToExcel}><i className="fa fa-download"></i> Excel</button>
                                    </div>
                                </div>
                            </div>
                          
                            <div className="box-body">
                                <div className="table-responsive" style={{width: '100%', height: 'calc(100vh - 260px)', overflow: 'auto', padding: '0 10px 10px 10px'}}>
                                    <table style={{whiteSpace: 'nowrap'}} className="table-sm table-bordered nowrap fs-10" id="printableArea" width='100%'>
                                        <thead>
                                            <tr className="text-dark text-center" style={{ position: 'sticky', top: 0, zIndex: 2, backgroundColor: '#f8f9fa' }}>
                                                <th>INVOICE NUMBER</th>
                                                <th>INVOICE DATE</th>
                                                <th>PARTY CODE</th>
                                                <th>PARTY NAME</th>
                                                <th>ITEM CODE</th>
                                                <th>ITEM</th>
                                                <th>HSN CODE</th>
                                                <th>QUANTITY</th>
                                                <th>UNIT PRICE</th>
                                                <th>TAXABLE VALUE</th>
                                                <th>GST RATE %</th>
                                                <th>CGST</th>
                                                <th>SGST</th>
                                                <th>IGST</th>
                                                <th>INVOICE TOTAL</th>
                                                <th>DISCOUNT</th>
                                                <th>ROUND OFF</th>
                                                <th>GRAND TOTAL</th>
                                                <th>SALES ACCOUNT</th>
                                                <th>CGST LEDGER</th>
                                                <th>SGST LEDGER</th>
                                                <th>IGST LEDGER</th>
                                                <th>COUNTRY</th>
                                                <th>STATE</th>
                                                <th>STATE CODE</th>
                                                <th>LOCATION</th>
                                                <th>VEHICLE NUMBER</th>
                                                <th>E-WAY BILL NUMBER</th>
                                                <th>VOUCHER TYPE</th>
                                                <th>UNITS</th>
                                                <th>GSTIN</th>
                                                <th>REGISTRATION TYPE</th>
                                            </tr>
                                           
                                        </thead>
                                        <tbody>
                                            {orderData?.length > 0 ? (
                                                <>
                                                 {flattened?.slice().reverse().map((row, index) => {

                                                    const price = parseFloat(row.price) || 0;
                                                    const qty = parseFloat(row.qty) || 0;
                                                    const crates = parseFloat(row.crates) || 0;
                                                    const gst = parseFloat(row.gst) || 0;
                                                    const weight = parseFloat(row.weight) || 0;
                                                    const packets = parseFloat(crates * qty) || 0
                                                    const totalWeight = parseFloat((crates * qty * weight) / 1000).toFixed(2);
                                                    const pricePerLTR = parseFloat((price / weight) * 1000);
                                                    const pricePerQty = parseFloat(price);
                                                    const unitPriceWOGst = parseFloat((gst > 0 ? price / (1 + (gst / 100)) : price)).toFixed(2);
                                                    const gstValue = parseFloat(price - unitPriceWOGst).toFixed(2);
                                                    
                                                    const total = parseFloat(packets * unitPriceWOGst).toFixed(2);
                                                    const taxable = gst > 0 ? total : 0;

                                                    const discountType = row.discount ? row.discount.type : null;
                                                    const discountValue = row.discount ? parseFloat(row.discount.value) : 0;
                                                    const discountSection = row.discount ? row.discount.discount : null;

                                                    // console.log(crates, qty, discountType, discountValue, discountSection);

                                                    let discountAmount = 0;
                                                    if(discountSection === 'amount' && discountValue > 0){
                                                        if(discountType === 'liters'){
                                                            discountAmount = totalWeight * discountValue;
                                                        }
                                                        if(discountType === 'percentage'){
                                                            discountAmount = (total * (discountValue / 100));
                                                        }
                                                        if(discountType === 'grade'){
                                                            discountAmount = (qty * discountValue);
                                                        }
                                                    }

                                                    const cgst = row.gstType === 'IGST' ? 0 : parseFloat(total * ((gst/2)/100)).toFixed(2);
                                                    const sgst = row.gstType === 'IGST' ? 0 : parseFloat(total * ((gst/2)/100)).toFixed(2);
                                                    const igst = row.gstType === 'IGST' ? parseFloat(total * (gst/100)).toFixed(2) : 0;

                                                    const gstTotal = parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst);
                                                    const invTotal = parseFloat(parseFloat(total) + parseFloat(gstTotal)).toFixed(2);
                                                    const grandTotTotal = parseFloat(invTotal - discountAmount).toFixed(5);
                                                    const finalPayment = Math.round(grandTotTotal);
                                                    const roundOff = (finalPayment - grandTotTotal).toFixed(2);

                                                    return (
                                                    <tr key={index}>
                                                        <td className="text-center">{`TRC/${row?.invoiceId}/${getFiscalYearLabel(new Date(row?.date))}`}</td>
                                                        <td className="text-center">{formatViewDate(row.date)}</td>
                                                        <td className="text-center">{row.dealerId}</td>
                                                        <td>{row.party}</td>
                                                        <td className="text-center">{row.itemCode}</td>
                                                        <td>{row.item}</td>
                                                        <td className="text-center">{row.hsn}</td>
                                                        <td className="text-end">{Number(packets).toFixed(2)}</td>
                                                        <td className="text-end">{Number(unitPriceWOGst).toFixed(2)}</td>
                                                        <td className="text-end">{Number(total).toFixed(2)}</td>
                                                        <td className="text-end">{Number(gst).toFixed(2)}</td>
                                                        <td className="text-end">{Number(cgst).toFixed(2)}</td>
                                                        <td className="text-end">{Number(sgst).toFixed(2)}</td>
                                                        <td className="text-end">{Number(igst).toFixed(2)}</td>
                                                        <td className="text-end">{Number(invTotal).toFixed(2)}</td>
                                                        <td className="text-end">-{Number(discountAmount).toFixed(2)}</td>
                                                        <td className="text-end">{Number(roundOff).toFixed(2)}</td>
                                                        <td className="text-end">{Number(finalPayment).toFixed(2)}</td>
                                                        <td className="text-center">GST SALES</td>
                                                        <td className="text-center">Central Tax (CGST)</td>
                                                        <td className="text-center">State Tax (SGST)</td>
                                                        <td className="text-center">Integrated (IGST)</td>
                                                        <td className="text-center">INDIA</td>
                                                        <td className="text-center">{row.state}</td>
                                                        <td className="text-center">{row.stateCode}</td>
                                                        <td className="text-center">{row.location}</td>
                                                        <td className="text-center">{row.vNum}</td>
                                                        <td className="text-center">{row.eWayNum}</td>
                                                        <td className="text-center">Gst sales</td>
                                                        <td className="text-center">Pkt</td>
                                                        <td className="text-center">{row.gstin}</td>
                                                        <td className="text-center">{row?.gstin?.length > 5 ? "Regular" : "Unregistered/Consumer"}</td>
                                                    </tr>
                                                
                                                    )}
                                                    
                                                    )}
                                                   
                                                  </>
                                                        ) : (
                                                        <tr>
                                                            <td colSpan="14" className="text-center">No Data Available</td>
                                                        </tr>
                                                    )}
                                       </tbody>

                                    </table>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

        </>
    );
}

export default LedgerReport;